"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _useInterval2 = _interopRequireDefault(require("../useInterval"));

var _useCarouselComponents = require("./useCarouselComponents");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* See useCarousel.README.md */
var useCarousel = function useCarousel() {
  var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      length = _useState2[0],
      setLength = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      activeIndex = _useState4[0],
      setActiveIndex = _useState4[1];

  var goPrev = (0, _react.useCallback)(function () {
    return setActiveIndex(function (currIndex) {
      /* We wrap our index if we are at the beginning, otherwise we move down one*/
      var newIndex = currIndex === 0 ? length - 1 : currIndex - 1;
      return newIndex;
    });
  }, [length]);
  var goNext = (0, _react.useCallback)(function () {
    return setActiveIndex(function (currIndex) {
      /* We wrap our index if we are at the end, otherwise we move up one*/
      var newIndex = currIndex === length - 1 ? 0 : currIndex + 1;
      return newIndex;
    });
  }, [length]);
  /* If delay exists, we set our useInterval */

  var _useInterval = (0, _useInterval2["default"])(goNext, delay),
      toggle = _useInterval.toggle,
      reset = _useInterval.reset;

  var carouselProps = {
    length: length,
    activeIndex: activeIndex,
    setActiveIndex: setActiveIndex,
    setLength: setLength,
    goPrev: goPrev,
    goNext: goNext,
    resetDelay: reset,
    toggle: toggle
  };
  return {
    carouselProps: carouselProps,
    Carousel: _useCarouselComponents.Carousel,
    PaginationDots: _useCarouselComponents.PaginationDots
  };
};

var _default = useCarousel;
exports["default"] = _default;